import styled from "styled-components";

export const ServiceUnavailableContainerSC = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    gap: 8px;
`;